/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnChanges, OnInit } from '@angular/core';

import { UntypedFormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api/selectitem';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { Tab } from '../../../core/model/tab.model';

/**
 * @export
 * @class QueryViewFilterTrainsComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 */
@Component({
  selector: 'lms-query-view-filter-trains',
  templateUrl: './query-view-filter-trains.component.html',
  styleUrls: ['./query-view-filter-trains.component.scss']
})
export class QueryViewFilterTrainsComponent implements OnInit, OnChanges {
  @Input() group: any;
  @Input() tab: Tab;
  @Input() commonopsPicklist;
  @Input() minMaxError;
  @Input() minMaxGPSError;
  @Input() tabIndex: number;
  trainForm: UntypedFormGroup;
  hotTrainList = [];
  hoursMin = 8;
  selectItem: SelectItem = { label: '--Select--', value: '' };
  hoursMax = 24;
  assignedUnitsMin = 0;
  dueOutWithNoPowerValue = 4;
  assignedUnitsMax = 15;
  noOfLocosList = [
    {
      label: 1,
      value: 1
    }, {
      label: 2,
      value: 2
    }, {
      label: 3,
      value: 3
    }, {
      label: 4,
      value: 4
    }, {
      label: '>4',
      value: '>4'
    }];
  constructor(private staticDataStoreService: StaticDataStoreService) { }
  /**
   *  this is angular life cycle this method init when template load
   * @memberof QueryViewFilterTrainsComponent
   */
  ngOnInit() {
    if (this.commonopsPicklist && this.commonopsPicklist.masterData) {
      this.setHotTrainList();
    }
  }

  /**
   * this method fill hot train dropdown
   * @memberof QueryViewFilterTrainsComponent
   */
  setHotTrainList() {
    const hotTrainList = this.commonopsPicklist.masterData.hotTrainList;
    this.hotTrainList.push(this.selectItem);
    for (let i = 0; i < hotTrainList.length; i++) {
      this.hotTrainList.push({
        label: hotTrainList[i],
        value: hotTrainList[i]
      });
    }
    this.trainForm.controls['hotTrainValue'].setValue(this.tab.queryView.hotTrainValue ? this.tab.queryView.hotTrainValue : (this.hotTrainList.length ? this.hotTrainList[0].value : ''));
  }

  /**
   * every time when input changes and before nginit it fire
   * @memberof QueryViewFilterTrainsComponent
   */
  ngOnChanges() {
    this.trainForm = this.group;
  }

  /**
   * by this method we check if we click on due out hour
   * then reset excude checkbox
   * @memberOf QueryViewFilterTrainsComponent
   */
  disableInput(): void {
    // to get correct value of radio set this things
    setTimeout(() => {
      if (this.trainForm.controls.trainCheck.value === 'dueOutHour') {
        this.trainForm.controls.excludeOriginatingTrains.setValue('');
      }
    }, 100);
  }

  /**
   * by this method we check min and  max control value
   * @param {string} minControl
   * @param {string} maxControl
   * @memberof QueryViewFilterTrainsComponent
   */
  checkRange(minControl: string, maxControl: string) {
    const minValue = this.trainForm.controls[minControl].value;
    const maxValue = this.trainForm.controls[maxControl].value;
    if (minValue > maxValue || maxValue < minValue) {
      this.trainForm.controls[minControl].setErrors({ 'minmax': true });
    } else {
      this.trainForm.controls[minControl].setErrors({ 'minmax': null });
    }
  }

}
